/* Artless enhancements — added by Claude, Jul 2026
   1. Video hero: click-to-unmute sound button (browsers require muted autoplay).
   2. Sticky top Add-to-Cart bar for the artless-pdp product page,
      matching the apdp-topbar in the "DRAFT - Blogs" theme (pill button, top). */
(function () {
  var css = [
    /* --- video hero sound button --- */
    '.artless-video-hero{position:relative;}',
    '.artless-video-sound{position:absolute;right:16px;bottom:16px;width:44px;height:44px;padding:0;margin:0;display:flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.7);border-radius:50%;background:rgba(22,19,17,.4);cursor:pointer;z-index:5;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);transition:background .2s ease;}',
    '.artless-video-sound:hover{background:rgba(22,19,17,.7);}',
    '.artless-video-sound svg{width:20px;height:20px;fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}',
    '.artless-video-sound .icon-unmuted{display:none;}',
    '.artless-video-sound:not(.is-muted) .icon-muted{display:none;}',
    '.artless-video-sound:not(.is-muted) .icon-unmuted{display:block;}',
    '@media(max-width:749px){.artless-video-sound{right:12px;bottom:12px;width:20px;height:20px;}.artless-video-sound svg{width:10px;height:10px;}}',
    /* --- sticky top add-to-cart bar (matches DRAFT-Blogs apdp-topbar) --- */
    '.artless-tb{display:none;}',
    '@media(max-width:749px){.artless-tb{display:block;position:fixed;top:0;left:0;right:0;z-index:70;background:#fff;border-bottom:1px solid #e6e4e0;padding:8px 14px;box-shadow:0 2px 10px rgba(0,0,0,.07);transform:translateY(-115%);transition:transform .22s ease;box-sizing:border-box;}.artless-tb.is-visible{transform:translateY(0);}}',
    '.artless-tb-inner{max-width:560px;margin:0 auto;display:flex;align-items:center;gap:12px;}',
    '.artless-tb-name{font-size:13px;font-weight:500;color:#161311;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}',
    '.artless-tb-add{margin:0 0 0 auto;flex:0 0 auto;width:auto;min-width:150px;min-height:44px;padding:10px 20px;background:#c2401e;color:#fff;border:1.5px solid #c2401e;border-radius:999px;font-family:inherit;font-size:13.5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;line-height:1;cursor:pointer;transition:background .22s ease;}',
    '.artless-tb-add:hover{background:#a53416;border-color:#a53416;}',
    '.artless-tb-add:disabled{background:#bcb2a6;border-color:#bcb2a6;cursor:not-allowed;}'
  ].join('');
  var style = document.createElement('style');
  style.setAttribute('data-artless', 'enhancements');
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);

  /* ---- 1. video hero sound ---- */
  function initHeroSound() {
    var v = document.querySelector('.artless-video-hero__media');
    if (!v || v.getAttribute('data-sound-init')) return;
    v.setAttribute('data-sound-init', '1');
    var wrap = (v.closest && v.closest('.artless-video-hero')) || v.parentNode;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'artless-video-sound is-muted';
    btn.setAttribute('aria-label', 'Turn sound on');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML =
      '<svg class="icon-muted" viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>' +
      '<svg class="icon-unmuted" viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a9 9 0 0 1 0 14"/></svg>';
    wrap.appendChild(btn);
    btn.addEventListener('click', function () {
      if (v.muted) {
        v.muted = false; v.volume = 1;
        var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
        btn.classList.remove('is-muted');
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', 'Turn sound off');
      } else {
        v.muted = true;
        btn.classList.add('is-muted');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Turn sound on');
      }
    });
  }

  /* ---- 2. sticky top add-to-cart bar ---- */
  function visibleAddButton() {
    var list = document.querySelectorAll('[data-add]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) return list[i];
    }
    return list[0] || null;
  }

  function initStickyBar() {
    var addBtn = visibleAddButton();
    if (!addBtn) return;                                   // only on the pdp
    if (document.querySelector('.apdp-topbar')) return;    // native sticky bar already present
    if (document.querySelector('.artless-tb')) return;     // avoid duplicates
    var titleEl = document.querySelector('.apdp-title');
    var bar = document.createElement('div');
    bar.className = 'artless-tb';
    bar.innerHTML =
      '<div class="artless-tb-inner">' +
        '<span class="artless-tb-name"></span>' +
        '<button type="button" class="artless-tb-add">Add to cart</button>' +
      '</div>';
    bar.querySelector('.artless-tb-name').textContent = titleEl ? titleEl.textContent.trim() : '';
    document.body.appendChild(bar);

    bar.querySelector('.artless-tb-add').addEventListener('click', function (e) {
      e.preventDefault();
      var real = visibleAddButton();
      if (real && !real.disabled) real.click();
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting && en.boundingClientRect.top < 0) bar.classList.add('is-visible');
        else bar.classList.remove('is-visible');
      });
    }, { threshold: 0 });
    io.observe(addBtn);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () { initHeroSound(); initStickyBar(); });
})();
